import type { ActionFlowNode, FlowNodeResultADT, SendMsgWxRootConfig } from '@lighthouse/shared'
import { t } from 'i18next'

import type { ExecuteActionParams } from '../type'

export const handleWechatPay = (
    node: ActionFlowNode<SendMsgWxRootConfig>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    throw new Error(t('cannotWechatPay'))
}
